import { render } from "./IDPGoals.vue?vue&type=template&id=c05fe526&scoped=true"
import script from "./IDPGoals.vue?vue&type=script&lang=js"
export * from "./IDPGoals.vue?vue&type=script&lang=js"

import "./IDPGoals.vue?vue&type=style&index=0&id=c05fe526&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05fe526"]])

export default __exports__